<svg
  class="block"
  [attr.width]="width"
  [attr.height]="height"
  fill="none"
  preserveAspectRatio="none"
  viewBox="0 0 17 8"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M12.8833 0.75C16.7053 0.75 16.7053 6.75 12.8833 6.75C9.06206 6.75 7.53356 0.75 3.32906 0.75C-0.109688 0.75 -0.109688 6.75 3.32906 6.75C7.53356 6.75 9.06206 0.75 12.8841 0.75H12.8833Z"
    stroke="var(--stroke-color)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
